import { useEffect, useState } from 'react';
import { getLatestMartyVersion } from '../../../../db/news-section-db';
import styles from './styles.module.css';
import modalState from '../../../../state-observables/modal/ModalState';

/* Modal explaining what the Danger indicator means, and what actions the user can take to resolve the issue */
export default function DangerModal() {
    const [latestMartyVersion, setLatestMartyVersion] = useState<string | null>(null);

    useEffect(() => {
        const asyncFunc = async () => {
            getLatestMartyVersion().then((latestMartyVersion) => setLatestMartyVersion(latestMartyVersion)).catch(() => setLatestMartyVersion(null));
        }
        asyncFunc();
    }, []);

    const onClose = () => {
        modalState.setModal(null, '');
    };

    return (
        <div className={styles.updateNotification}>
            <h2>Great News – Your Marty Has an Update!</h2>
            <br />
            <p>
                Exciting times! We've enhanced Marty with new features and improvements.
                To experience all these fantastic changes, please update your Marty to the latest version (v{latestMartyVersion}).
                Your adventure with Marty is about to get even better!
            </p>
            <br />
            <p>If you need a hand with the update process, don’t worry! Our detailed <a href="https://userguides.robotical.io/martyv2/userguides/marty/updating" target="_blank" rel="noreferrer">User Guide</a> is here to help.</p>
            <div className={styles.closeModalButtonContainer}>
                <button className={styles.closeModalButton} onClick={onClose}>Understood, Thanks!</button>
            </div>
        </div>
    );
}

